import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ScheduleApplicationRow } from "../scheduleApplicationRowHelpers";
import { getScheduleApplicationSourceLabel } from "../scheduleApplicationStatusDisplay";

export const ScheduleApplicationTypeCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ScheduleApplicationRow, string>) => {
        const label = getScheduleApplicationSourceLabel(row.original);
        if (label === null) {
            return <ViewTableCell />;
        }
        return <ViewTableCell>{label}</ViewTableCell>;
    },
);
ScheduleApplicationTypeCell.displayName = "ScheduleApplicationTypeCell";
